import { Box, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Loader from "../components/Loader";
import Summary from "../components/Summary";
import { formatProfileRow } from "../helpers/formatProfileRow";
import { getProfilesData } from "../helpers/getData";
import useContainerStyles from "../styles/container";

export default (props) => {
  const { theme, iso } = props;
  const containerClasses = useContainerStyles(theme);

  const [data, setData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      if (data) return;
      if (!iso) return null;

      const allProfiles = await getProfilesData().then((d) => d.map((row) => formatProfileRow(row)));
      const sumProfile = allProfiles.filter((d) => d.iso3 === iso);

      if (!sumProfile.length) return null;

      const year = sumProfile[0].year;

      setData({ sumProfile, allProfiles, year });
    };

    loadData();
  });

  return !data ? (
    <Loader />
  ) : (
    <Grid container justifyContent="center" pt={0} className={containerClasses.isSecondary} style={{ padding: "0px", background: "#fff" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ padding: "30px 20px" }}>
        <Box boxShadow={2}>
          <Summary sumProfile={data.sumProfile} allProfiles={data.allProfiles} year={data.year} showTitle={false} />
        </Box>
      </Grid>
    </Grid>
  );
};
